export function formatPublicMoney(value: number | string | null | undefined, currency?: string | null): string {
  const amount = Number(value);
  const code = String(currency || "").trim().toUpperCase();
  if (!Number.isFinite(amount) || !code) return "Request quote";
  return `${code} ${amount.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}
